module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Google Recaptcha v3":"Google Recaptcha v3","Website key":"Webseitenschlüssel","Private key":"Geheimer Schlüssel"}}')
  delete Component.options._Ctor
}
